import React, { Component } from "react";
import PropTypes from "prop-types";
import { Card, CardTitle, CardText } from "react-md/lib/Cards";
import { DataTable, TableBody, TableRow, TableColumn } from "react-md/lib/DataTables";
import PNXLabel from "components/PhoenixFormsV4/Controls/PNXLabel.tsx";
import { classes } from "components/Utility";

class PhoenixFormValidation extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.validationMessages?.length)
            return <div />;

        return (
            <div>
                <Card className={classes("md-cell md-cell--12 form-validation-issues", this.props.className)}>
                    <CardTitle title={this.props.title} />
                    <CardText>
                        <DataTable plain className="md-cell--12"
                            style={{ borderTopColor: "lightgray", borderTopStyle: "solid", borderTopWidth: "thin" }}>
                            <TableBody>
                                {this.props.validationMessages.map((item, index) => (
                                    <PhoenixFormValidationItem key={index} index={index} validationItem={item} handleClick={this.props.handleClick} />
                                ))}
                            </TableBody>
                        </DataTable>
                    </CardText>
                </Card>
            </div>
        );
    }
}

PhoenixFormValidation.propTypes = {
    validationMessages: PropTypes.array.isRequired,
    handleClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
};

class PhoenixFormValidationItem extends Component {
    constructor(props) {
        super(props);

        this.clicked = this.clicked.bind(this);
    }

    clicked() {
        this.props.handleClick(this.props.validationItem);
    }

    render() {
        

        return (
            <TableRow className="validation-item" key={this.props.index} style={{ cursor: "pointer" }} onClick={this.clicked}>
                <TableColumn><PNXLabel>{this.props.validationItem.fullErrorMessage ?? this.props.validationItem.errorMessage}</PNXLabel></TableColumn>
            </TableRow>
        );
    }
}

PhoenixFormValidationItem.propTypes = {
    index: PropTypes.number.isRequired,
    validationItem: PropTypes.object.isRequired,
    handleClick: PropTypes.func.isRequired,
};

export default PhoenixFormValidation;
